import React from "react";
import "../styles/Termsofuse.css";


const Legal = () => {
return (
<div className="legal-wrapper">
<main className="legal-main">
<h1>Package Delivery Terms and Conditions</h1>
{/* Removed the 'effective-date' as requested, but keeping the class for styling consistency if needed */}

<h4>Berymo Package Delivery Service:</h4>
<p>
These Terms and Conditions govern the use of the Berymo Package Delivery Service ("Delivery Service") offered to riders ("Users") within the Berymo application. The Delivery Service allows Users to arrange for the transport of eligible packages by Berymo drivers ("Contractors") for a flat fee or per-mile rate, as defined in the application. By utilizing the Delivery Service, the User agrees to these terms, which are in addition to the general Berymo Terms of Service.
</p>

<h3>1. Package Eligibility and Requirements</h3>
<p>
To ensure the safety of our Contractors and compliance with all regulations, packages must strictly adhere to the following requirements:
</p>
<ul>
<li><strong>Weight Limit:</strong> All packages must weigh **no more than 25 pounds (11.3 kilograms)**. Contractors reserve the right to decline any package suspected of exceeding this limit.</li>
<li><strong>Size and Dimensions:</strong> Packages must fit comfortably within the trunk or passenger area of a standard sedan or vehicle and must not obstruct the Contractor's view or impede their safe operation of the vehicle.</li>
<li><strong>Secure Sealing:</strong> All packages must be **securely and completely sealed** in appropriate packaging (e.g., box, envelope, container) to prevent spillage, loss, or damage during transport.</li>
<li><strong>Identification:</strong> The User is responsible for clearly and legibly marking the package with the recipient's name, address, and contact information.</li>
</ul>

<h2>2. Prohibited Items</h2>
<p>
Users are strictly prohibited from sending the following items via the Delivery Service. Sending prohibited items may result in immediate account deactivation and notification to law enforcement.
</p>
<ul>
<li>Weapons, firearms, ammunition, and their components.</li>
<li>Explosives, flammable materials, hazardous waste, or toxic substances.</li>
<li>Illegal drugs, controlled substances, and drug paraphernalia.</li>
<li>Live animals or human remains.</li>
<li>Stolen goods or property.</li>
<li>Cash, negotiable instruments, or currency (though Berymo is not responsible for any loss of value).</li>
<li>Items that are fragile, perishable, or require temperature control, unless expressly agreed upon by Berymo.</li>
<li>Any item whose possession or transport is illegal in the pick-up, drop-off, or transit locations.</li>
</ul>

<h3>3. User Responsibilities</h3>
<ul>
<li><strong>Accuracy:</strong> The User is solely responsible for the accuracy of the pick-up and drop-off addresses and for providing all necessary access information.</li>
<li><strong>Insurance and Value:</strong> The User acknowledges that Berymo is a transportation service and not a common carrier. Berymo does not provide insurance for the package contents, and the User agrees that Berymo's liability for package loss or damage is strictly limited to the service fee paid for the delivery.</li>
<li><strong>Recipient Availability:</strong> The User is responsible for ensuring the recipient is available at the drop-off location to receive the package. A package will be considered successfully delivered once the Contractor has reached the designated drop-off location and made reasonable attempts to transfer the package to the recipient.</li>
</ul>

<h2>4. Driver's Right to Refuse</h2>
<p>
Contractors have the right to inspect a package and may refuse to accept or continue the delivery of any package if the Contractor reasonably suspects the package:
</p>
<ul>
<li>Violates the weight or size requirements.</li>
<li>Contains prohibited items.</li>
<li>Is not securely sealed or may cause damage to the Contractor's vehicle.</li>
<li>Is not suitable for transport due to odors, excessive mess, or other safety concerns.</li>
</ul>

<h2>5. Fees and Payment</h2>
<p>
The User will be charged the Delivery Service fee agreed upon at the time of booking. By requesting a delivery, the User authorizes Berymo to charge the payment method on file for the full amount of the delivery service, including any applicable surcharges for extended wait times or failed delivery attempts due to User or recipient non-compliance.
</p>

<p className="mt-6">
By utilizing the Berymo Package Delivery Service, the User confirms acceptance of these specific terms and conditions.
</p>
</main>

</div>
);
};

export default Legal;
